import { render, staticRenderFns } from "./Form.html?vue&type=template&id=96c4c624&scoped=true&"
import script from "./Form.js?vue&type=script&lang=js&"
export * from "./Form.js?vue&type=script&lang=js&"
import style0 from "./Form.scss?vue&type=style&index=0&id=96c4c624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c4c624",
  null
  
)

export default component.exports